export default {
  companyInfo: '公司信息',
  companyName: '公司名称',
  legalPerson: '法人/主负责人（公司）',
  nameNoteAndCompanyName: '名称备注/原公司名',
  nickName: '昵称',
  nature: '公司类别', // 公司/个人/工作室/国际学校/其他
  natureNote: '类别说明',
  location: '所在区域',
  companyAddress: '公司详细地址',
  parentName: '所属父代理',
  taxCode: '税号/统一社会信用代码（公司）',
  isSettlementPort: '佣金是否单独结算', // 0否/1是
  idCardNum: '身份证号（个人/法人）',
  firstContractTime: '合同首次创建时间',
  firstOfferItemTime: '首次创建申请时间',
  remark: '备注',
  accountList: '账号列表',
  authorityQuery: '权限查询',
  businessDataManagement: '业务数据管理',
  subcompanyList: '分公司列表',
  roleType: '角色类型',
  department: '部门',
  administrator: '管理者',
  finance: '财务',
  subagentDataOpenSet: '子代理数据开放设置',
  bmsDataOpenSet: 'BMS数据开放设置',
  businessSupervisor: '业务上司',
  viewSubordinate: '查看下属',
  companyNumber: '编号',
  legalPersonName: '法人姓名',
  largeArea: '大区',
  area: '区域',
  bindStudentNum: '绑定学生数',
  addAccount: '新增账号',
  editAccount: '编辑账号',
  mobile: '移动电话',
  mobileAreaCode: '移动电话区号',
  telAreaCode: '固定电话区号',
  tel: '固定电话',
  // isCommissionEmail: '是否合同佣金联系邮箱',
  // isNewsEmail: '是否业务新闻接收邮箱',
  isCommissionEmail: '收取合同佣金',
  isNewsEmail: '接收推广电邮',
  deleteContactConfirm: '您确定要删除该账号信息吗？',
  account: '账号',
  setBusinessSuperior: '设置业务上司',
  loginInfo: '登录默认账号信息',
  defaultAccount: '账号',
  defaultPwd: '默认密码',
  messagingSoftware1: "通讯软件1",
  messagingSoftware2: "通讯软件2",
  accountFormMobileTips: '初始密码为手机号码后6位',
  accountFormEmailTips: '初次登录需要核验邮箱，请确保输入为本人邮箱，核验账户生效后，账户邮箱不能再进行修改。',
  isSetCommissionEmailTips: '当前用户为唯一佣金联系邮箱，请指定新佣金联系人邮箱后再进行取消操作。',
}
